import { useGetIdentity } from 'ra-core';
import { useQuery } from '@tanstack/react-query';
import { getUserProfile } from '../../dataProvider/dataProvider';
import { Navigate } from 'react-router-dom';

export const CompleteProfilePage = () => {
  const { data: user, isLoading: isLoadingUser } = useGetIdentity();
  const { data: userProfile, isLoading: isLoadingUserProfile } = useQuery({
    queryKey: [user?.idpUserId],
    queryFn: async () => {
      return getUserProfile().then(profile =>
        profile ? profile : { message: 'no-profile' }
      );
    },
    enabled: !isLoadingUser,
  });

  if (isLoadingUserProfile) return null;
  if (isLoadingUser) return null;

  if (userProfile?.id) {
    return <Navigate to="/" />;
  }

  return (
    <div className="flex flex-col items-center gap-4">
      <img
        alt="logo"
        src="https://storage.googleapis.com/public-goloot-production/goloot/goloot-logo-white.png"
        style={{ height: 32 }}
      />
      <h5 className="text-lg font-semibold">{`Profile incomplete`}</h5>
    </div>
  );
};
